import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#fff",
    maxHeight: "auto",
    paddingButtom: "10%",
    height: "100vh",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#5675D3",
    },

    [theme.breakpoints.down("951")]: {
      height: "130vh",
      paddingButtom: "0",
    },
  },
  divPayung: {
    display: "none",
    justifyContent: "center",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      justifyContent: "center",
    },
  },
  payung: {
    height: "15%",
    position: "absolute",
    marginTop: "6%",
    marginLeft: "-8%",
  },
  gelombang: {
    width: "100%",
    bottom: 0,
    position: "absolute",
    [theme.breakpoints.down("1156")]: {
      width: "10%",
    },
  },
  houseToko: {
    width: "100%",
    bottom: 0,
    position: "absolute",
  },
  content: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      textAlign: "center",
      marginLeft: "50%",
    },
    [theme.breakpoints.down("1156")]: {
      marginLeft: 0,
    },
  },
  boxContent: {
    backgroundColor: "#fff",
    width: "550px",
    height: "500px",
    marginTop: "2%",
    borderRadius: 5,

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#fff",
      width: "800px",
      height: "auto",
      marginRight: 50,
      boxShadow: "0px 6px 6px #726e6e73",
    },
    [theme.breakpoints.down("1156")]: {
      marginTop: "10",
      marginRight: 0,
      // width: "800px",
    },
  },
  textContent: {
    fontSize: "20px",
    textAlign: "center",
    marginTop: "20%",
    fontWeight: "bold",

    [theme.breakpoints.up("tablet")]: {
      fontSize: "20px",
      textAlign: "center",
      marginTop: "20%",
      fontWeight: "bold",
    },
  },
  textContent1: {
    fontWeight: "500",
  },
  textContent2: {
    color: "#5675D3",
  },
  textContent3: {
    backgroundColor: "#fff",
    display: "inline-block",
    width: "75%",
    fontSize: 18,
    fontWeight: "bold",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#fff",
      display: "inline-block",
      width: "30%",
      fontSize: 14,
      fontWeight: "bold",
      marginBottom: -10,
    },
  },
  garisContent: {
    height: 1,
    width: "2",
    backgroundColor: "grey",
    marginTop: -37,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 50,

    [theme.breakpoints.up("tablet")]: {
      height: 1,
      width: "1",
      backgroundColor: "grey",
      marginTop: -20,
      marginLeft: 20,
      marginRight: 20,
      marginBottom: 25,
    },
  },
  textContent4: {
    marginTop: 30,
  },
  form: {
    marginTop: 90,
    width: "70%",
  },
  textCopyright: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "30%",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "0%",
    },
  },
  textCopyrightH5: {
    color: "#5675D3",
    marginTop: 10,

    [theme.breakpoints.up("tablet")]: {
      color: "#fff",
      position: "absolute",
      marginTop: 90,
    },
  },
  formBottom: {
    width: "90%",
    height: "10%",
    marginTop: 5,
    marginBottom: 10,

    [theme.breakpoints.up("tablet")]: {
      width: "30%",
    },
  },
  textErr: {
    fontSize: "9px",
    color: "red",
    alignItems: "center",
    textAlign: "left",
    marginTop: 0,
    marginBottom: 5,
    marginLeft: "8%",
    display: "flex",
    fontWeight: "500",
    width: "350px",
  },
  textErr1: {
    fontSize: "9px",
    color: "red",
    textAlign: "left",
    marginTop: 0,
    marginBottom: -2,
    marginLeft: "8%",
  },
  textErrAlamat: {
    fontSize: "9px",
    color: "red",
    textAlign: "left",
    marginTop: -26,
    marginBottom: 20,
    marginLeft: "8%",
  },
}));
export default useStyles;
